export const FaultShowSceneTranslation = {
  fi: {
    FaultShowScene: {
      backLink: 'Takaisin',
      businessName: 'Asiakasyritys',
      vehicle: 'Ajoneuvo',
      vehicleLink: 'Avaa ajoneuvo',
      userName: 'Ilmoittaja',
      createdAt: 'Luotu',
      status: 'Tila',
      statusOpen: 'Avoin',
      statusDone: 'Valmis',
      description: 'Kuvaus',
      markAsRead: 'Merkitse luetuksi',
      markAsUnread: 'Merkitse lukemattomaksi',
      toastMarkedAsRead: 'Vikailmoitus merkittiin luetuksi.',
      toastMarkedAsUnread: 'Vikailmoitus merkittiin lukemattomaksi.',
    },
  },
};
